// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Hashtbl = require("bs-platform/lib/js/hashtbl.js");
var Slugify = require("./slugify");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Js_primitive = require("bs-platform/lib/js/js_primitive.js");
var SortEnSeance = require("./sortEnSeance");
var MaterialUIIcons = require("bs-material-ui-icons/lib/js/src/MaterialUIIcons.js");
var LogoGouvernementPng = require("./logo-gouvernement.png");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

((require('./amendement.css')));

var component = ReasonReact.statelessComponent("Amendement");

function make(amendementWrapper, discussion, onOpenLinkedContent, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var match = amendementWrapper[/* amendement */1];
      if (match) {
        var amendement = match[0];
        var match$1 = discussion[/* numeroProchainADiscuter */5];
        var placeRe = (/(article|chapitre|titre)\s+(\d+|[cilvx]+|1er|Ier|premier)(\s+([a-f]|bis|ter|quater|quinquies))?/i);
        var param = placeRe.exec(amendementWrapper[/* place */13]);
        var placeMatch = param !== null ? Js_primitive.null_undefined_to_opt(Caml_array.caml_array_get(param, 0)) : /* None */0;
        var tmp;
        if (placeMatch) {
          var placeSlug = Slugify.slugifySectionNumber(placeMatch[0]);
          var exit = 0;
          var linkedContentPage;
          try {
            linkedContentPage = Hashtbl.find(discussion[/* pages */7], placeSlug);
            exit = 1;
          }
          catch (exn){
            if (exn === Caml_builtin_exceptions.not_found) {
              tmp = null;
            } else {
              throw exn;
            }
          }
          if (exit === 1) {
            tmp = ReasonReact.element(/* None */0, /* None */0, MaterialUI.Button[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[Curry._2(onOpenLinkedContent, amendement, linkedContentPage)], /* None */0, /* None */0, /* Some */["Lire l'article du projet de loi."], /* Some */[/* Fab */0], /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.LibraryBooks[/* make */0](/* array */[]))]));
          }
          
        } else {
          tmp = null;
        }
        var match$2 = amendement[/* dispositif */5];
        var match$3 = amendement[/* exposeSommaire */7];
        var auteur = amendement[/* auteur */0];
        var tmp$1;
        if (auteur[/* estGouvernement */2]) {
          tmp$1 = React.createElement("div", {
                style: {
                  display: "inline-flex",
                  margin: "0px auto",
                  alignItems: "center"
                }
              }, React.createElement("img", {
                    style: {
                      height: "100px",
                      width: "auto",
                      flex: "1"
                    },
                    title: "Le Gouvernement",
                    alt: "Logo du Gouvernement",
                    src: LogoGouvernementPng
                  }), React.createElement("div", {
                    style: {
                      paddingLeft: "10px",
                      flex: "10"
                    }
                  }, Model.ste("Amendement proposé par le Gouvernement")));
        } else {
          var match$4 = auteur[/* qualite */7];
          var match$5 = amendement[/* cosignatairesMentionLibre */4];
          tmp$1 = React.createElement("div", {
                style: {
                  display: "inline-flex",
                  margin: "0px auto",
                  alignItems: "center"
                }
              }, React.createElement("img", {
                    style: {
                      height: "100px",
                      width: "auto",
                      flex: "1"
                    },
                    title: auteur[/* prenom */6] + (" " + auteur[/* nom */4]),
                    alt: "Portrait de " + (auteur[/* civilite */0] + (" " + (auteur[/* prenom */6] + (" " + auteur[/* nom */4])))),
                    src: auteur[/* photoUrl */5]
                  }), React.createElement("div", {
                    style: {
                      paddingLeft: "10px",
                      flex: "10"
                    }
                  }, React.createElement("strong", undefined, Model.ste(auteur[/* civilite */0] + (" " + (auteur[/* prenom */6] + (" " + (auteur[/* nom */4] + ((
                                      match$4 ? match$4[0] : ""
                                    ) + (
                                      match$5 ? " " + match$5[0][/* titre */0] : ""
                                    )))))))), React.createElement("br", undefined), Model.ste(Model.groupeTitleFromAuteurGroupe(auteur, amendementWrapper[/* auteurGroupe */2]))));
        }
        var cosignataires = amendement[/* cosignataires */3];
        return React.createElement("article", {
                    id: Curry._1(Slugify.slugify, amendementWrapper[/* numero */11])
                  }, React.createElement("div", {
                        style: {
                          display: "flex",
                          justifyContent: "space-between"
                        }
                      }, React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Subheading */6], /* array */[Model.ste(amendementWrapper[/* place */13])])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h3"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[{
                                      marginBottom: "16px"
                                    }], /* Some */[/* Display1 */3], /* array */[
                                    Model.ste("Amendement " + amendement[/* numeroLong */10]),
                                    match$1 && match$1[0] === amendementWrapper[/* numero */11] ? React.createElement("span", {
                                            style: {
                                              color: "orange"
                                            }
                                          }, ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Whatshot[/* make */0](/* array */[]))) : null,
                                    ReasonReact.element(/* None */0, /* None */0, SortEnSeance.make(amendement[/* sortEnSeance */15], /* array */[]))
                                  ]))), tmp), match$2 ? React.createElement("div", undefined, React.createElement("h4", {
                              style: {
                                textTransform: "uppercase"
                              }
                            }, Model.ste("Titre")), React.createElement("div", {
                              style: {
                                wordWrap: "break-word"
                              },
                              dangerouslySetInnerHTML: {
                                __html: match$2[0]
                              }
                            })) : null, match$3 ? React.createElement("div", {
                          style: {
                            backgroundColor: "#ebebeb",
                            borderBottom: "3px solid #979797",
                            padding: "10px"
                          }
                        }, React.createElement("h4", {
                              style: {
                                textTransform: "uppercase"
                              }
                            }, Model.ste("Exposé sommaire")), React.createElement("div", {
                              style: {
                                wordWrap: "break-word"
                              },
                              dangerouslySetInnerHTML: {
                                __html: match$3[0]
                              }
                            })) : null, tmp$1, cosignataires.length !== 0 ? React.createElement("div", undefined, React.createElement("h4", undefined, Model.ste(Pervasives.string_of_int(cosignataires.length) + " Co-signataires :")), React.createElement("ul", {
                              className: "amendement-cosignataires"
                            }, $$Array.mapi((function (i, cosignataire) {
                                    var match = cosignataire[/* qualite */7];
                                    var match$1 = amendement[/* cosignatairesMentionLibre */4];
                                    return React.createElement("li", {
                                                key: Pervasives.string_of_int(i)
                                              }, Model.ste(cosignataire[/* civilite */0] + (" " + (cosignataire[/* prenom */6] + (" " + (cosignataire[/* nom */4] + ((
                                                              match ? match[0] : ""
                                                            ) + (
                                                              match$1 ? " " + match$1[0][/* titre */0] : ""
                                                            ))))))));
                                  }), cosignataires))) : null);
      } else {
        var match$6 = discussion[/* numeroProchainADiscuter */5];
        return React.createElement("article", {
                    id: Curry._1(Slugify.slugify, amendementWrapper[/* numero */11])
                  }, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Subheading */6], /* array */[Model.ste(amendementWrapper[/* place */13])])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h3"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[{
                              marginBottom: "16px"
                            }], /* Some */[/* Display1 */3], /* array */[
                            Model.ste("Amendement " + amendementWrapper[/* numero */11]),
                            match$6 && match$6[0] === amendementWrapper[/* numero */11] ? React.createElement("span", {
                                    style: {
                                      color: "orange"
                                    }
                                  }, ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Whatshot[/* make */0](/* array */[]))) : null,
                            ReasonReact.element(/* None */0, /* None */0, SortEnSeance.make(amendementWrapper[/* sort */15], /* array */[]))
                          ])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.LinearProgress[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[])));
      }
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/amendement.re
// module id = 1671
// module chunks = 0